import styled, { css } from 'styled-components';
import Anchor from '@tcp/core/src/components/common/atoms/Anchor';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import Row from '@tcp/core/src/components/common/atoms/Row';

const StickySearchKeywordStyles = css`
  @media ${(props) => props.theme.mediaQuery.mediumMax} {
    z-index: 5;
    background-color: #fff;
    ${(props) =>
      props.isHeaderScrollViewDisabled &&
      !props.isGlobalHeaderRedesignEnabled &&
      props.isHeaderSticky
        ? `position: fixed;  top: 66px;`
        : ''}
  }
  @media ${(props) => props.theme.mediaQuery.mediumOnly} {
    ${(props) =>
      props.isHeaderScrollViewDisabled &&
      !props.isGlobalHeaderRedesignEnabled &&
      props.isHeaderSticky
        ? `top: 62px;`
        : ''}
  }
`;

const NewSearchedTextTitleStyles = css`
  line-height: 1;
  @media ${(props) => props.theme.mediaQuery.mediumOnly} {
    margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
  }
  @media ${(props) => props.theme.mediaQuery.large} {
    line-height: 1.22;
    margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.LRG};
  }
`;

export const NewSearchedTextTitleRow = styled(Row)`
  ${(props) => !props?.acrossBrandApiCalled && StickySearchKeywordStyles}
  ${(props) => props.isABTestForStickyFilter && NewSearchedTextTitleStyles}
`;

export const SearchedLabel = styled(BodyCopy)`
  display: inline-block;

  @media ${(props) => props.theme.mediaQuery.mediumOnly} {
    padding-bottom: ${(props) => (props.isSlpPersistEnabled ? '0px' : '28px')};
  }
  @media ${(props) => props.theme.mediaQuery.medium} {
    padding-left: 6px;
  }
  @media ${(props) => props.theme.mediaQuery.large} {
    padding-bottom: 0;
  }
`;

export const NullSearchCount = styled(BodyCopy)`
  margin: 4px 13px 0;
  @media only screen and (max-width: 1200px) {
    margin: 4px 15px 0;
  }
`;

export const NewProductCountTextSearch = styled(BodyCopy)`
  padding-left: 5px;
  font-weight: ${(props) => props.theme.fonts.fontWeight.normal};
`;

export const RelatedSearchWrapper = styled.div`
  display: flex;
  margin: 10px 0px 10px 13px;
  @media ${(props) => props.theme.mediaQuery.large} {
    margin: ${(props) =>
      !props.searchTopPromos?.length
        ? ` 3px 0px 0px 13px`
        : `4px 0px ${props.theme.spacing.ELEM_SPACING.XL} 13px`};
    ${(props) => !props.searchTopPromos?.length && `position: absolute; z-index:1;`}
  }
`;

export const RelatedText = styled.div`
  font-family: ${(props) => props.theme.typography.fonts.secondary};
  font-weight: ${(props) => props.theme.fonts.fontWeight.semiBold};
  color: ${(props) => props.theme.colors.PRIMARY.DARK};
  font-size: ${(props) => props.theme.typography.fontSizes.fs14};
  @media ${(props) => props.theme.mediaQuery.mediumMax} {
    font-size: ${(props) => props.theme.typography.fontSizes.fs12};
  }
`;

export const RelatedSearches = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const SlpPersistRelatedSearch = styled(Anchor)`
  color: ${(props) => props.theme.colors.TEXT.BLUE};
  padding-left: ${(props) => props.theme.spacing.ELEM_SPACING.XS};
  font-weight: ${(props) => props.theme.fonts.fontWeight.bold};
  font-size: ${(props) => props.theme.typography.fontSizes.fs14};
  @media ${(props) => props.theme.mediaQuery.mediumMax} {
    font-size: ${(props) => props.theme.typography.fontSizes.fs12};
  }
`;

export const SearchedText = styled(BodyCopy)`
  font-weight: 400;
  margin-bottom: 3px;
  @media only screen and (max-width: 1200px) {
    font-size: 18px;
  }
`;

export const EnteredText = styled(BodyCopy)`
  font-weight: 600;
  margin-bottom: 13px;
  @media only screen and (max-width: 1200px) {
    font-size: 12px;
  }
`;

export const SlpInsteadSearch = styled(Anchor)`
  color: #005d95;
`;
